import { render } from "./privacy_checkbox.vue?vue&type=template&id=4219dd26"
import script from "./privacy_checkbox.vue?vue&type=script&lang=js"
export * from "./privacy_checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__